export default __webpack_public_path__ + "badminton-pre.png";